/**
 * @generated SignedSource<<8254fe23534fa4f57eac31b790fb2c74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type KPIEditAdminTeamMutation$variables = {
  routineId: string;
  teamId: string;
};
export type KPIEditAdminTeamMutation$data = {
  readonly routine: {
    readonly update: {
      readonly routine: {
        readonly id: string;
        readonly team: {
          readonly id: string;
        };
      } | null;
    } | null;
  } | null;
};
export type KPIEditAdminTeamMutation = {
  response: KPIEditAdminTeamMutation$data;
  variables: KPIEditAdminTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "routineId"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "setTeamId",
                "variableName": "teamId"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UpdateRoutinePayload",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditAdminTeamMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditAdminTeamMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5c74e862cab3f5e9b11fd430151db8f0",
    "id": null,
    "metadata": {},
    "name": "KPIEditAdminTeamMutation",
    "operationKind": "mutation",
    "text": "mutation KPIEditAdminTeamMutation(\n  $routineId: ID!\n  $teamId: ID!\n) {\n  routine(id: $routineId) {\n    update(input: {setTeamId: $teamId}) {\n      routine {\n        id\n        team {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6c2822d69868bdb75e92d683c12ff6b";

export default node;
